import { ASTEROID_DATA } from "../src/constants/asteroids";
import { CLIENT_VERSION } from "../src/constants/version";
import { PacketType } from "../src/enum/PacketType";
import { PacketValueSerialType } from "../src/enum/PacketValueSerialType";
import { PlayerClassType } from "../src/enum/PlayerClassType";
import { Input, KeyCode } from "../src/lib/Input";
import MonoBehavior from "../src/lib/MonoBehavior";
import NetEngine from "../src/lib/NetEngine";
import { Time } from "../src/lib/Time";
import Vector2 from "../src/math/Vector2";
import Asteroid from "../src/scripts/Asteroid";
import Chat from "../src/scripts/Chat";
import CTFFlag from "../src/scripts/CTFFlag";
import GameManager from "../src/scripts/GameManager";
import Player from "../src/scripts/Player";
import { GenerateRandomUsername } from "../src/util";
import { Random } from "../src/util/Random";
import { Shapes } from "../src/util/Shapes";

class Game extends NetEngine {

    protected onPlayerJoin(clientId: string, playerName: string): void {
        const [obj, test] = this.NewGameObjectWithScript<Player>(Player, clientId);
        test.isOwner = false;
        test.name = playerName;

        if (!this.clientPlayer) return;
        this.sendPacket(PacketType.SetPlayerClass, packet => {
            packet.writeBytes(this.clientPlayer?.class?.type ?? PlayerClassType.Fighter);
        });

        this.clientPlayer.SyncFullState();

        this.addLog(`${playerName} has joined!`);
    }

    protected onPlayerLeave(clientId: string): void {
        const player: Player = this.GetGameObject(clientId)?.GetScript(Player);
        this.addLog(`${player.name} has left.`);
        this.RemoveGameObject(clientId);
    }

    protected onWelcome(clientId: string, playerList: { id: string; name: string; }[]): void {
        const [localObj, localScript] = this.NewGameObjectWithScript<Player>(Player, this.clientId);
        localObj.transform.position = new Vector2(
            Random.int(0, 128),
            Random.int(-128, 0)
        );
        localScript.name = this.clientName;
        this.clientPlayer = localScript;

        for (const player of playerList) {
            if (player.id === this.clientId) continue;

            const [obj, playerBehavior] = this.NewGameObjectWithScript<Player>(Player, player.id);
            playerBehavior.isOwner = false;
            playerBehavior.name = player.name;
        }

        const [, redFlag] = this.NewGameObjectWithScript<CTFFlag>(CTFFlag, "red-flag");
        const [, blueFlag] = this.NewGameObjectWithScript<CTFFlag>(CTFFlag, "blue-flag");
        redFlag.team = "red";
        blueFlag.team = "blue";

        redFlag.transform.position = GameManager.spawns.red;
        blueFlag.transform.position = GameManager.spawns.blue;
    }

    protected LateUpdate(): void {
        super.LateUpdate();

        if (Input.GetKeyDown(KeyCode.Backspace) && Input.GetKey(KeyCode.ControlLeft) && Input.GetKey(KeyCode.ShiftLeft)) {
            this.drawGizmos = !this.drawGizmos;
        }

        if (Input.GetKeyDown(KeyCode.F11) || (Input.GetKeyDown(KeyCode.Enter) && Input.GetKey(KeyCode.AltLeft))) {
            this.canvas.requestFullscreen();
        }
    }

    protected onAfterDraw(): void {
        this.ctx.save();
        this.ctx.filter = `grayscale(100%) blur(4px)`;
        this.ctx.globalCompositeOperation = 'lighten';
        this.ctx.drawImage(this.canvas, 0, 0);
        this.ctx.restore();
    }
}

const Main = (name: string) => {

    // const host = "http://localhost:8080";
    const host = "https://nightly.nnll.sh/ws";

    const game = new Game(name || GenerateRandomUsername(), host, document.querySelector("canvas#canvas") as HTMLCanvasElement, {
        background: 'black',
        foreground: '#55ff55'
    });

    //init asteroids
    for (const _asteroid of  ASTEROID_DATA) {
        const [, asteroid] = game.NewGameObjectWithScript<Asteroid>(Asteroid);
        asteroid.transform.position = Vector2.fromObject(_asteroid.position);
        asteroid.pointVectors = _asteroid.pointVectors.map(v => Vector2.fromObject(v));
    }

    // const li: Asteroid[] = [];
    // for (let i = 0; i < 200; i++) {
    //     const [, asteroid] = game.NewGameObjectWithScript<Asteroid>(Asteroid);
    //     asteroid.transform.position.x = Random.int(-5000, 5000);
    //     asteroid.transform.position.y = Random.int(-5000, 5000);

    //     li.push(asteroid);
    // }

    // console.log(JSON.stringify(li.map(v => {
    //     return {
    //         position: v.transform.position.toObject(),
    //         pointVectors: v.pointVectors.map(w => w.toObject())
    //     }
    // })));
    //

    game.NewGameObjectWithScript<GameManager>(GameManager, "game-manager");
    game.NewGameObjectWithScript<Chat>(Chat);
    
    game.drawGizmos = false;
    game.Start();
}

window.addEventListener("load", () => {
    //@ts-ignore
    document.querySelector("#client-version").innerHTML = CLIENT_VERSION;
    const nameInput = document.querySelector('#nameInput') as HTMLInputElement;
    const errDiv = document.querySelector('#name-error') as HTMLDivElement;
    nameInput.placeholder = GenerateRandomUsername();

    document.querySelector("button#btnSubmit")?.addEventListener("click", e => {
        errDiv.innerHTML = '';
        const name = /^\s*$/.test(nameInput.value) ? nameInput.placeholder : nameInput.value;

        if (!/^[a-z\d]{2,24}$/i.test(name)) {
            errDiv.innerHTML = `Name must be only letters and numbers, between 2 and 24 characters`;
            return;
        }

        document.querySelector("#namePanel")?.remove();
        Main(name);
    });
});